import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionSuccess = () => {
	const navigate = useNavigate();
	const [countdown, setCountdown] = useState(5);

	useEffect(() => {
		const timer = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					clearInterval(timer);
					navigate("/form_page");
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, [navigate]);

	return (
		<div className="py-[50px] md:py-[100px] bg-gray-50 min-h-screen">
			<div className="container mx-auto px-4">
				<div className="max-w-md mx-auto text-center">
					<div className="bg-white rounded-2xl shadow-lg p-8">
						<div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
							<svg
								className="w-10 h-10 text-green-500"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M5 13l4 4L19 7"
								/>
							</svg>
						</div>
						<h1 className="text-2xl md:text-3xl font-bold mb-4 text-green-600">
							Subscription Successful!
						</h1>
						<p className="text-gray-600 mb-6">
							Thank you for subscribing! Your account has been upgraded and you
							now have full access to all premium features.
						</p>
						<p className="text-gray-500 mb-6">
							Redirecting in {countdown} seconds...
						</p>
						<button
							type="button"
							onClick={() => navigate("/form_page")}
							className="w-full py-3 px-4 darkBlue text-white rounded-xl hover:opacity-90 transition-opacity"
						>
							Continue to App
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionSuccess;
